import React from 'react';
import useClientHook from '../../Hooks/useClientHook';

function MultipleOrigins({onSelect, logins, show}) {
    let {logo} = useClientHook('LOGIN');

    return (
        <div className='p-4 position-absolute w-100 h-100 justify-content-center align-items-center text-center' style={{background:'#fff', left:0, top:0, display: show?'flex':'none'}}>
            <div className='w-100' style={{maxWidth:400}}>
                <img className="img-fluid mb-4" src={logo} alt='Lock' style={{maxWidth: 60, width:60}}/>
                <h2 className='fw-bold'>You have multiple accounts</h2>
                <p>Select account in which you want to login</p>
                <div className='w-100 mt-4 d-flex flex-column' style={{fontSize:'0.8rem'}}>
                    {
                        logins&&logins.map((origin, index)=>{
                            return <button onClick={()=>onSelect(origin.origin)} key={index} className={`text-center btn btn-outline-dark text-truncate rounded-3 p-2 ps-3 mt-2`}>
                                {origin?.origin} ACCOUNT
                            </button>
                        })
                    }
                </div>
            </div>
        </div>
    );
}

export default MultipleOrigins;